import { post, get } from "./axios"; // put, deleteFun
export function login(data) {
  return post({
    url: `/common/login/index`,
    data: {
      params: JSON.stringify({ ...data }),
    },
  });
}
export function getInfo(token) {
  return get({ url: `/common/login/getUserInfo?token=${token}`, token });
}
export function logout() {
  return post({ url: "/common/login/logout" });
}
export function editManagerInfo() {
  return get({ url: "/common/login/editManagerInfo" });
}
export function updateManagerInfo(data) {
  return post({ url: "/common/login/updateManagerInfo", data });
}
// 菜单列表
export function getRoutes(params) {
  return get({
    url: "/common/RolePermission/treeData",
    data: {
      ...params,
    },
  });
}
// 角色列表
export function getRoles(params) {
  return get({
    url: "/common/RolePermission/getRoleList",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 新建角色
export function addRole(params) {
  return post({
    url: "/common/RolePermission/addRole",
    data: { params: JSON.stringify({ ...params }) },
  });
}
// 新建角色
export function updateRole(params) {
  return post({
    url: "/common/RolePermission/updateRole",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 获取角色信息
export function getRoleInfo(id) {
  return get({
    url: "/common/RolePermission/getRoleInfo",
    data: {
      id,
    },
  });
}
// 删除角色
export function deleteRole(id) {
  return get({
    url: "/common/RolePermission/deleteRole",
    data: {
      id,
    },
  });
}
export function HandlePermissionCache() {
  return get({
    url: "/common/RolePermission/HandlePermissionCache",
  });
}
export function updateBdStatus(data) {
  return get({
    url: "/common/RolePermission/updateBdStatus",
    data: {
      data: JSON.stringify({ ...data }),
    },
  });
}
//更新角色部门
export function postUpdateRoleDepartmentReq(params) {
  return post({
    url: "/common/RolePermission/updateRoleDepartment",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
//获取部门角色权限
export function getDepartmentValueReq() {
  return post({
    url: "/common/RolePermission/getDepartmentValue",
  });
}

// 新建菜单
export function addMenu(params) {
  return post({
    url: "/common/RolePermission/addMenu",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 菜单列表
export function getMenuList(params) {
  return get({
    url: "/common/RolePermission/getMenuList",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 菜单 get
export function getMenuDetail(id) {
  return get({
    url: "/common/RolePermission/getMenu",
    data: {
      id,
    },
  });
}

// 菜单 update
export function updateMenu(params) {
  return get({
    url: "/common/RolePermission/updateMenu",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 后台人员列表
export function getManagersList(params) {
  return get({
    url: "/common/RolePermission/getManagersList",
    data: {
      params: JSON.stringify({ ...params }),
      pageSize: 100,
    },
  });
}
// 新建管理员
export function createManager(params) {
  return post({
    url: "/common/RolePermission/createManager",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 管理员信息
export function getManagerInfo(id) {
  return get({
    url: "/common/RolePermission/getManagerInfo",
    data: {
      id,
    },
  });
}
// edit管理员
export function updateManager(params) {
  return post({
    url: "/common/RolePermission/updateManager",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 删除后台客户
export function deleteManagerUser(id) {
  return post({
    url: "/common/RolePermission/deleteManagerUser",
    data: {
      id,
    },
  });
}
/**
 * 管理员上下级
 */
export function getManagerCacheList() {
  return get({
    url: "/common/RolePermission/getManagerCacheList",
  });
}
export function updateMannagerEffective(data) {
  return post({
    url: "/common/RolePermission/updateManagerEffective",
    data,
  });
}
export function updateMannagerStatus(ID) {
  return get({
    url: "/common/RolePermission/statusSave",
    ID,
  });
}
// 后台人员操作日志
export function getManagerLogList(params) {
  return get({
    url: "/common/RolePermission/getManagerLogList",
    params,
  });
}
/**
 * 操作权限-create
 */
export function createHandlePermission(params) {
  return post({
    url: "/common/RolePermission/createHandlePermission",
    params,
  });
}
/**
 *
 * 操作权限列表
 */
export function HandlePermissionList(params) {
  return get({
    url: "/common/RolePermission/HandlePermissionList",
    params,
  });
}
/**
 * 获取系统开关信息
 */
export function getSystemStatus() {
  return get({
    url: "/common/RolePermission/getSystemStatus",
  });
}
/**
 * 修改传输状态
 */
export function changeSystemTran(data) {
  return get({
    url: "/common/RolePermission/changeSystemTran",
    data,
  });
}

// 列表
export function getDepartment() {
  return get({
    url: "/common/RolePermission/departmentList",
  });
}

export function addDepartment(params) {
  return get({
    url: "/common/RolePermission/addDepartment",
    params,
  });
}

export function getDepartmentInfo(params) {
  return get({
    url: "/common/RolePermission/getDepartment",
    params,
  });
}

export function deletedDepartment(params) {
  return get({
    url: "/common/RolePermission/deletedDepartment",
    params,
  });
}

export function getUserList(params) {
  return get({
    url: "/common/user/list",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 菜单列表
export function checkPermissionRole(role) {
  return get({
    url: "/common/RolePermission/userRole",
    role,
  });
}

export function getDistrict(params) {
  return post({
    url: "/common/districts",
    params,
  });
}

// 客户编辑 - 付款方式 是否显示

export function memberTabPay() {
  return get({
    url: "/common/user/memberTab",
  });
}

// 客户资质时效
export function getUserLicence(user_id) {
  return get({
    url: "/common/user/licence",
    data: {
      user_id,
    },
  });
}

// 修改客户资质时效
export function updateLicence(formUserSx) {
  return post({
    url: "/common/user/licence",
    data: {
      formUserSx: JSON.stringify(formUserSx),
    },
  });
}
// 推广员列表
export function getSalesList() {
  return get({
    url: "/common/user.User/salesManList",
  });
}

// 客户-推广员信息
export function getUserSalesManRe(user_id) {
  return get({
    url: "/common/user.User/userSalesMan",
    data: {
      user_id,
      channel: 0,
    },
  });
}
// 更新-客户-推广员员信息
export function updateSaleManRe(user_id, params) {
  return post({
    url: "/common/user/saleManRe",
    data: {
      user_id,
      params,
    },
  });
}

// 客户编辑 -查询客户付款方式
export function payMethods(id) {
  return get({
    url: "/common/user/payWayDetail",
    data: { id },
  });
}
// 客户编辑 -保存客户付款方式
export function savePayMethods(params) {
  return post({
    url: "/common/user/payWaySave",
    data: {
      ...params,
    },
  });
}

// 管理员列表
export function getManageRole(id = null) {
  return get({
    url: "/common/user/managerList",
    id,
  });
}
// 客户-管理员信息
export function getUserManageRe(user_id) {
  return get({
    url: "/common/user/userGly",
    data: {
      user_id
    },
  });
}
// 更新-客户-管理员信息
export function updateManageRe(user_id, params) {
  return post({
    url: "/common/user/manageRe",
    data: {
      user_id,
      params,
    },
  });
}
// 客户经营范围
export function getUserJyfw(user_id) {
  return get({
    url: "/common/user/businessScope",
    data: {
      user_id,
    },
  });
}
// 更新经营范围
export function updateJyfw(user_id, params) {
  console.log(user_id, params)
  return post({
    url: "/common/user/updateBusinessScope",
    data: {
      user_id,
      params,
    },
  });
}
// 同步经营范围
export function syncErpUserJyfw(ID) {
  return get({
    url: "/common/user/syncErpBusinessScope",
    data: {
      ID,
    },
  });
}

// 经营范围
export function businessScopeList() {
  return get({
    url: "/common/User/businessScopeList",
  });
}

// 修改基本信息
export function updateUser(fromBase) {
  return post({
    url: "/common/user/updateUser",
    data: {
      fromBase: JSON.stringify({ ...fromBase }),
    },
  });
}
// 资质审核列表
export function getUserQualifyList(params) {
  return get({
    url: "/common/user/getUserQualifyList",
    data: params,
  });
}
// 资质审核详情
export function getUserQualifyAudit(params) {
  return get({
    url: "/common/user/getUserQualifyAudit",
    data: params,
  });
}
//
export function checkUserQualify(params) {
  return post({
    url: "/common/user/checkUserQualify",
    data: params,
  });
}

// Show基本信息
export function showUser(user_id) {
  return get({
    url: "/common/user/showUser",
    data: {
      user_id,
    },
  });
}
// 签约客户
export function updateUserMEMBERSHIP(params) {
  return get({
    url: "/common/user/updateUserMEMBERSHIP",
    data: {
      params,
    },
  });
}

// 加盟客户
export function updateUserFRANCHISE(params) {
  return get({
    url: "/common/user/updateUserFRANCHISE",
    data: {
      params,
    },
  });
}

// 审核
export function updateUserREVIEW(params) {
  return get({
    url: "/common/user/updateUserREVIEW",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// VIP
export function updateUserVIP(params) {
  return get({
    url: "/common/user/updateUserVIP",
    data: {
      params,
    },
  });
}

// 指定经营范围
export function updateUserSPECIFIED(params) {
  return get({
    url: "/common/user/updateUserSPECIFIED",
    data: {
      params,
    },
  });
}

// 检验报告
export function updateUserINSPECTION(params) {
  return get({
    url: "/common/user/updateUserINSPECTION",
    data: {
      params,
    },
  });
}

// 状态
export function updateUserSTATUS(params) {
  return get({
    url: "/common/user/updateUserSTATUS",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 开启推广员到付
export function updateUserCASHONDELIVERY(params) {
  return get({
    url: "/common/user/updateUserCASHONDELIVERY",
    data: {
      params,
    },
  });
}
// erp拦截
export function updateErpPayOff(params) {
  return get({
    url: "/common/user/updateErpPayOff",
    data: {
      params,
    },
  });
}

// 货到付款拦截
export function updateHdfkPayOff(params) {
  return get({
    url: "/common/user/updateHdfkPayOff",
    data: {
      params,
    },
  });
}
// 重置密码
export function resetPassword(params) {
  return post({
    url: "/common/user/resetPassword",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 同步erp信息
export function syncErpUserAddress(params) {
  return get({
    url: "/common/user/syncErpUser",
    data: {
      params,
    },
  });
}
// get 首营 info
export function syncFirstUserInfo(params) {
  return get({
    url: "/common/PayInfo/synchronization_user",
    data: {
      ...params,
    },
  });
}
// 线下账期拦截
export function updateErpPayOff_xx(params) {
  return get({
    url: "/common/user/updateErpPayOff_xx",
    method: "get",
    data: {
      ...params,
    },
  });
}
// 是否新客户
export function updateNewCustomer(params) {
  return get({
    url: "/common/user/updateNewCustomer",
    data: {
      ...params,
    },
  });
}
// 手动获取客户经纬度
export function getStreetReq(data) {
  return get({
    url: "/common/user/getStreet",
    data: {
      ...data,
    },
  });
}

// 客户收货信息
export function getUserAddress(user_id) {
  return get({
    url: "/common/user/address",
    data: {
      user_id,
    },
  });
}

// 更新客户收货信息
export function updateAddress(params) {
  return get({
    url: "/common/user/updateAddress",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 同步erp地址
export function sys_address(ID) {
  return get({
    url: "/common/user/erpAddress",
    data: {
      ID,
    },
  });
}

// 重置客户名
export function updateResetUserName(params) {
  return get({
    url: "/common/user/resetName",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 客户基本信息
export function getUser(user_id) {
  return get({
    url: "/common/user/userInfo",
    data: {
      user_id,
    },
  });
}

// 客户子账号列表
export function getUserChildReq(params) {
  return get({
    url: "/common/user/userChild",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 获取客户账户使用日志
export function getUserAccountLogList(params) {
  return get({
    url: "/common/userAccount/detail",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 账户余额、积分变动
export function createChangeMoney(params) {
  return post({
    url: "/common/userAccount/changeMoney",
    data: {
      params,
    },
  });
}
// 账户充值余额变动
export function createChargeMoney(params) {
  return post({
    url: "/common/userAccount/createChargeMoney",
    data: {
      params,
    },
  });
}

/**
 * 调节欠款
 */
export function updateQkMoney(params) {
  return post({
    url: "/common/userAccount/updateQkMoney",
    data: {
      params,
    },
  });
}

/**
 * 调节红包金币
 */
export function updateJbHongBao(params) {
  return post({
    url: "/common/userAccount/updateJbHongBao",
    data: {
      params,
    },
  });
}
/**
 * 爆品金
 * @param {*} params
 */
export function updateBaoPinJin(params) {
  return post({
    url: "/common/userAccount/updateBaoPinJin",
    data: {
      params,
    },
  });
}
/**
 * 签到记录
 * @param {客户ID} params
 */
export function getSignLogList(params) {
  return get({
    url: "/common/userAccount/getSignLogList",
    data: {
      params,
    },
  });
}

//手机号绑定列表
export function getMobileListReq(params) {
  return get({
    url: "/common/mobile/mobileList",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
//单个手机号关联账号
export function getShowUserRelationReq(params) {
  return get({
    url: "/common/mobile/showUserRelation",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// get tms info
export function syncTmsInfo(id) {
  return get({
    url: "/common/user/syncTmsInfo",
    data: {
      id,
    },
  });
}
// 订单详情->客户账户信息
export function getUserAccountInfo(id) {
  return get({
    url: "/common/userAccount/info",
    data: {
      id,
    },
  });
}

// 搜索获取客户信息
export function getMemberInfo(params) {
  return get({
    url: "/common/user/getMemberInfo",
    data: {
      params,
    },
  });
}

// 省市区
export function getAllDistricts(params) {
  return get({
    url: "/common/districtsTree",
    data: params,
  });
}

// 基础配置 - 查询客户类型
export function getMemberTypeList(params) {
  return get({
    url: "/common/basic/userType/list",
    data: params,
  });
}
// 新增客户类型
export function insertMemberType(params) {
  return post({
    url: "/common/basic/userType/create",
    data: params,
  });
}
// 编辑客户类型
export function updateMemberType(params) {
  return post({
    url: "/common/basic/userType/edit",
    data: params,
  });
}
// 配置资质
export function editUserQualification(params) {
  return post({
    url: "/common/basic/userType/editUserQualification",
    data: params,
  });
}
// 资质查询
export function getQualificationList(params) {
  return get({
    url: "/common/basic/userQualification/list",
    data: params,
  });
}
// 新增资质
export function insertQualification(params) {
  return post({
    url: "/common/basic/userQualification/create",
    data: params,
  });
}
// 编辑资质
export function updateQualification(params) {
  return post({
    url: "/common/basic/userQualification/edit",
    data: params,
  });
}
// 编辑状态
export function updateStatusQualification(params) {
  return post({
    url: "/common/basic/userQualification/editStatus",
    data: params,
  });
}
// 删除
export function delZizhi(params) {
  return post({
    url: "/common/basic/userQualification/del",
    data: params,
  });
}
// 协议
export function getUserAgreement(params) {
  return get({
    url: "/common/basic/userAgreement/info",
    data: params,
  });
}
// 配置协议
export function updateUserAgreement(params) {
  return post({
    url: "/common/basic/userAgreement/edit",
    data: params,
  });
}
// 查询经营类别
export function getBusinessScopeList(params) {
  return get({
    url: "/common/basic/businessScope/list",
    data: params,
  });
}
// 新增经营类型
export function insertBusinessScope(params) {
  return post({
    url: "/common/basic/businessScope/create",
    data: params,
  });
}
// 编辑经营类型
export function editBusinessScope(params) {
  return post({
    url: "/common/basic/businessScope/edit",
    data: params,
  });
}
// 删除经营类别
export function delBusinessScope(params) {
  return post({
    url: "/common/basic/businessScope/delete",
    data: params,
  });
}
// 查询商品资质
export function getGoodsQualificationList(params) {
  return get({
    url: "/common/basic/goodsQualification/list",
    data: params,
  });
}
// 新增商品资质
export function insertGoodsQualification(params) {
  return post({
    url: "/common/basic/goodsQualification/create",
    data: params,
  });
}
// 编辑商品资质
export function editGoodsQualification(params) {
  return post({
    url: "/common/basic/goodsQualification/edit",
    data: params,
  });
}
// 删除商品资质
export function delGoodsQualification(params) {
  return post({
    url: "/common/basic/goodsQualification/delete",
    data: params,
  });
}
// 查询物流配置
export function getExpressDeliveryList(params) {
  return get({
    url: "/common/basic/expressDelivery/list",
    data: params,
  });
}
// 新增物流配置
export function insertExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/create",
    data: params,
  });
}
// 编辑物流配置
export function editExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/edit",
    data: params,
  });
}
// 删除物流配置
export function delExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/delete",
    data: params,
  });
}
// 修改物流状态
export function editStatusExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/editStatus",
    data: params,
  });
}
// 全局配置
export function getBasicConfig(params) {
  return get({
    url: "/common/basic/config/list",
    data: params,
  });
}
// 修改全局配置
export function editBasicConfig(params) {
  return post({
    url: "/common/basic/config/edit",
    data: params,
  });
}

// 新增商家
export function insertMerchant(params) {
  return post({
    url: "/common/adminUser/createMerchant",
    data: params,
  });
}
//  查询商家列表
export function getListMerchant(params) {
  return get({
    url: "/common/adminUser/listMerchant",
    data: params,
  });
}
export function getInfoMerchant(params) {
  return get({
    url: "/common/adminUser/infoMerchant",
    data: params,
  });
}
// 修改可售区域
export function editDisMerchant(params) {
  return post({
    url: "/common/adminUser/editDistrict",
    data: params,
  });
}
// 编辑商户经营范围
export function editMerchantBusinessScope(params) {
  return post({
    url: "/common/adminUser/editBusinessScope",
    data: params,
  });
}
// 编辑商家
export function editMerchant(params) {
  return post({
    url: "/common/adminUser/editMerchant",
    data: params,
  });
}
// 编辑商家状态
export function editMerchantStatus(params) {
  return post({
    url: "/common/adminUser/editMerchantStatus",
    data: params,
  });
}
export function editMerchantAccount(params) {
  return post({
    url: "/common/adminUser/editMerchantAccount",
    data: params,
  });
}

// 标签列表查询
export function getSalesmanTagList(params) {
  return get({
    url: "/common/salesman/salesmanTag/list",
    data: params,
  });
}
// 新增标签
export function insertSalesmanTag(params) {
  return post({
    url: "/common/salesman/salesmanTag/create",
    data: params,
  });
}
// 编辑标签
export function editSalesmanTag(params) {
  return post({
    url: "/common/salesman/salesmanTag/edit",
    data: params,
  });
}
// 删除标签
export function delSalesmanTag(params) {
  return post({
    url: "/common/salesman/salesmanTag/delete",
    data: params,
  });
}
// 修改标签状态
export function editSalesmanStatus(params) {
  return post({
    url: "/common/salesman/salesmanTag/editStatus",
    data: params,
  });
}

// 标签列表查询
export function getSalesmanTagTypeList(params) {
  return get({
    url: "/common/salesman/tagType/list",
    data: params,
  });
}
// 新增标签
export function insertSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/create",
    data: params,
  });
}
// 编辑标签
export function editSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/edit",
    data: params,
  });
}
// 删除标签
export function delSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/delete",
    data: params,
  });
}
// 修改标签状态
export function editSalesmanTagTypeStatus(params) {
  return post({
    url: "/common/salesman/tagType/editStatus",
    data: params,
  });
}

// 修改标签状态
export function getTagsByType(params) {
  return post({
    url: "/common/salesman/tagType/getTagsByType",
    data: params,
  });
}

//  推广员列表查询
export function getSalesmanList(params) {
  return get({
    url: "/common/salesman/salesman/list",
    data: params,
  });
}
// 新增推广员
export function insertSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/create",
    data: params,
  });
}
// 修改推广员
export function editSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/edit",
    data: params,
  });
}
// 删除推广员
export function delSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/delete",
    data: params,
  });
}
// 修改推广员状态
export function editStatusSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/editStatus",
    data: params,
  });
}
// 推广员-客户列表
export function getSalesmanUserList(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/listUser",
    data: params,
  });
}
export function insertSalesmanUser(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/createUser",
    data: params,
  });
}
export function deleteSalesmanUser(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/deleteUser",
    data: params,
  });
}
// 根据商品获取区域
export function getPreviousArea(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/parentDistrict",
    data: params,
  });
}
// 推广员-商品列表
export function getSalesmanGoodsList(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/list",
    data: params,
  });
}
export function insertSalesmanGoods(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/create",
    data: params,
  });
}
export function editSalesmanGoods(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/edit",
    data: params,
  });
}

export function delGoodsSalesman(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/delete",
    data: params,
  });
}

// 客户购物车列表
export function getCartInfoList(params) {
  return get({
    url: "/common/user.User/getCartInfoList",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// 客户购物车明细
export function getCartInfoDetail(params) {
  return get({
    url: "/common/user.User/getCartInfoDetail",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// 地区码表
export function getDistrictsTree(params) {
  return get({
    url: "/common/districtsTree",
    data: params,
  });
}
export function addDistrictTree(params) {
  return post({
    url: "/common/addDistrict",
    data: params,
  });
}
export function delDistrictTree(params) {
  return post({
    url: "/common/delDistrict",
    data: params,
  });
}
// 财务管理 - 货款
export function goodsPaymentList(params) {
  return get({
    url: "/common/finance/settlement/goodsPaymentList",
    data: params,
  });
}
// 财务管理- 佣金
export function royaltyMoneyList(params) {
  return get({
    url: "/common/finance/settlement/royaltyMoneyList",
    data: params,
  });
}
// 财务管理- 运费
export function freightAmountList(params) {
  return get({
    url: "/common/finance/settlement/freightAmountList",
    data: params,
  });
}
// 客户提现申请
export function userWithdrawList(params) {
  return get({
    url: "/common/finance/withdraw/userWithdrawList",
    data: params,
  });
}
// 推广员提现申请
export function salesmanWithdrawList(params) {
  return get({
    url: "/common/finance/withdraw/salesmanWithdrawList",
    data: params,
  });
}
// 商家提现申请
export function merchantWithdrawList(params) {
  return get({
    url: "/common/finance/withdraw/merchantWithdrawList",
    data: params,
  });
}
// 商品关联的推广员
export function getGoodsContactSalesman(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/goodsListSalesman",
    data: params,
  });
}
//公共商品搜索接口
export function getCommonGetGoodsReq(params) {
  return get({
    url: "/common/getGoods",
    data: params,
  });
}

//基础配置-商品资质库-列表
export function getBasicGoodsQualificationListReq(params) {
  return get({
    url: "/common/basic/goodsQualification/list",
    data: params,
  });
}
//基础配置-商品资质库-新增
export function postBasicGoodsQualificationCreateReq(params) {
  return post({
    url: "/common/basic/goodsQualification/create",
    data: params,
  });
}
//基础配置-商品资质库-编辑
export function postBasicGoodsQualificationEditReq(params) {
  return post({
    url: "/common/basic/goodsQualification/edit",
    data: params,
  });
}
//基础配置-商品资质库-删除
export function postBasicGoodsQualificationDeleteReq(params) {
  return post({
    url: "/common/basic/goodsQualification/delete",
    data: params,
  });
}

// 客户类型
export function getQualificationType(params) {
  return get({
    url: "/common/user.qualification/type",
    data: params,
  })
}

//#region  平台配置 客户类型
//客户类型 列表
export function getBasicUserTypeListReq(params) {
  return get({
    url: "/common/basic/userType/list",
    data: params,
  });
}
//客户类型 新增
export function postBasicUserTypeCreateReq(params) {
  return post({
    url: "/common/basic/userType/create",
    data: params,
  });
}
//客户类型 编辑
export function postBasicUserTypeEditReq(params) {
  return post({
    url: "/common/basic/userType/edit",
    data: params,
  });
}
//客户类型 删除
export function postBasicUserTypeDeleteReq(params) {
  return post({
    url: "/common/basic/userType/delete",
    data: params,
  });
}
//客户类型 配置资质
export function postBasicUserTypeEditUserQualificationReq(params) {
  return post({
    url: "/common/basic/userType/editUserQualification",
    data: params,
  });
}

//#endregion
//#region  平台配置 经营类别 配置资质
export function postBasicBusinessScopeEditGoodsQualificationReq(params) {
  return post({
    url: "/common/basic/businessScope/editGoodsQualification",
    data: params,
  });
}

//#endregion

//#region 红包
//列表
export function getUserAccountHongbaoListReq(params) {
  return get({
    url: "/common/userAccount/hongbaoList",
    data: params,
  });
}

//变动明细
export function getUserAccountHongbaoLogReq(params) {
  return get({
    url: "/common/userAccount/hongbaoLog",
    data: params,
  });
}


//#endregion